import type { ObjectDirective } from 'vue';

const vPasswordToggle: ObjectDirective = {
  mounted(el: HTMLElement) {
    const waitForInput = () => {
      // Find the real input element inside the component
      const input = el.querySelector('input[type="password"], input[type="text"]') as HTMLInputElement | null;

      if (!input) {
        // Retry after a short delay if the input isn't rendered yet
        setTimeout(waitForInput, 50);
        return;
      }

      // Prevent duplicate wrapper
      if (input.dataset.hasPasswordToggle === 'true') return;
      input.dataset.hasPasswordToggle = 'true';

      const wrapper = document.createElement('div');
      wrapper.classList.add('password-toggle-wrapper');
      input.parentNode?.insertBefore(wrapper, input);
      wrapper.appendChild(input);

      input.classList.add('password-toggle-input');

      const toggle = document.createElement('i');
      toggle.classList.add('fa', 'fa-eye', 'password-toggle-icon');
      wrapper.appendChild(toggle);

      const showPassword = () => {
        input.type = 'text';
        toggle.classList.remove('fa-eye');
        toggle.classList.add('fa-eye-slash');
        resetAutoHide();
      };

      const hidePassword = () => {
        input.type = 'password';
        toggle.classList.remove('fa-eye-slash');
        toggle.classList.add('fa-eye');
        clearTimeout((input as any).__passwordToggleTimeout);
      };

      const resetAutoHide = () => {
        clearTimeout((input as any).__passwordToggleTimeout);
        (input as any).__passwordToggleTimeout = setTimeout(hidePassword, 10000);
      };

      toggle.addEventListener('click', () => {
        if (input.type === 'password') {
          showPassword();
        } else {
          hidePassword();
        }
      });

      input.addEventListener('input', () => {
        if (input.type === 'text') resetAutoHide();
      });

      input.addEventListener('blur', () => {
        if (input.type === 'text') hidePassword();
      });
    };

    waitForInput();
  },

  unmounted(el: HTMLElement) {
    const input = el.querySelector('input[type="password"], input[type="text"]') as HTMLInputElement | null;
    if (input && (input as any).__passwordToggleTimeout) {
      clearTimeout((input as any).__passwordToggleTimeout);
    }
  }
};

export default vPasswordToggle;
